var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { NestedError } from './nested_error';
import { waitAll } from './promise';
/**
 * Concurrently map over an array of promises with a concurrency bound.
 * At any given time there are at most <code>options.concurrency</code> concurrent executions going on.
 *
 * When a single execution fails, no more work is scheduled, but all ongoing executions are waited to finish.
 * All caught errors are thrown as a single AggregateError.
 */
export function boundedConcurrentMap(items, mapper, options) {
    return __awaiter(this, void 0, void 0, function* () {
        if (options.concurrency < 1) {
            throw new Error('Concurrency has to be > 0');
        }
        const concurrency = Math.min(options.concurrency, items.length);
        const queue = items.map((value, index) => [index, value]);
        const results = [];
        let isFailed = false;
        const worker = () => __awaiter(this, void 0, void 0, function* () {
            while (queue.length !== 0) {
                if (isFailed) {
                    break;
                }
                const elem = queue.shift();
                if (elem === undefined) {
                    break;
                }
                const [index, item] = elem;
                try {
                    results[index] = yield mapper(item, index);
                }
                catch (e) {
                    isFailed = true;
                    throw e;
                }
            }
        });
        try {
            yield waitAll(new Array(concurrency).fill(undefined).map(worker));
        }
        catch (e) {
            throw new NestedError('boundedConcurrentMap failed with: ', e);
        }
        return results;
    });
}
//# sourceMappingURL=bounded_concurrent_map.js.map